import { Form, Input, InputNumber, message, Modal } from 'antd';
import { FC, useEffect } from 'react';
import styles from './index.less';
import ExerciseTreeCom from '@/pages/backend/cardCampSettings/nodeSettings/exerciseCom/exerciseTreeCom';
import { isEmpty, isUndefined } from 'lodash';
import FixQuestionSelect from '@/pages/backend/cardCampSettings/nodeSettings/exerciseCom/fixQuestionSelect';
import { ExerciseObj } from './exerciseCom';
import { create32LengthUUID } from '@/utils/index';

type Props = {
  visible: boolean;
  onCancel: () => void;
  onOk: (data: ExerciseObj) => void;
  activeExercise?: ExerciseObj;
};

const ExerciseModal: FC<Props> = (props) => {
  const { visible, onCancel, onOk, activeExercise } = props;
  const [form] = Form.useForm();
  const title = Form.useWatch('title', form);
  const category = Form.useWatch('selectedCategories', form);

  //useEffect(() => {
  //  if (!visible) {
  //    form.setFieldsValue({});
  //    form.resetFields();
  //  } else {
  //    if (activeExercise) {
  //      form.setFieldsValue({ ...activeExercise });
  //    } else {
  //      form.setFieldsValue({});
  //    }
  //  }
  //}, [visible]);
  useEffect(() => {
    console.log('activeExercise', activeExercise);
    if (activeExercise) {
      form.setFieldsValue({ ...activeExercise });
    }
  }, [activeExercise, form]);
  console.log('title是', title);
  const formDom = () => {
    return (
      <>
        <Form.Item name="id" hidden />
        <Form.Item
          name="title"
          label="分类标题"
          rules={[{ required: true, message: '请输入分类标题' }]}
        >
          <Input placeholder="请输入" maxLength={20} showCount />
        </Form.Item>
        <Form.Item name="description" label="分类说明">
          <Input placeholder="请输入" maxLength={100} showCount />
        </Form.Item>
        <Form.Item
          name="rewardPer"
          label="每题奖励"
          rules={[{ required: true, message: '请输入每题奖励' }]}
        >
          <InputNumber placeholder="请输入" min={0} precision={0} addonAfter="学分" />
        </Form.Item>
        <Form.Item
          name="selectedCategories"
          label="抽题题目分类"
          help="请选择随机抽题来源的题库分类，可以选择多个"
        >
          <ExerciseTreeCom />
        </Form.Item>
        {!isEmpty(category) && (
          <Form.Item
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}
            name="selectedNums"
            label="抽题数量"
            rules={[{ message: '请设置抽题数量', required: true }]}
          >
            <InputNumber placeholder="请输入" min={1} precision={0} addonAfter="个" />
          </Form.Item>
        )}
        <Form.Item name="regularQuestion" label="固定题目">
          <FixQuestionSelect
            isEdit={!isUndefined(activeExercise)}
            initValue={activeExercise?.regularQuestion}
          />
        </Form.Item>
      </>
    );
  };
  return (
    <Modal
      //afterClose={() => {
      //  setTimeout(() => {
      //    console.log('执行重置');
      //    form.setFieldsValue(undefined);
      //    form.resetFields();
      //  });
      //}}
      destroyOnClose
      wrapClassName={styles.exercise_modal}
      width={950}
      title={activeExercise ? '修改抽题规则' : '添加抽题规则'}
      open={visible}
      onCancel={onCancel}
      centered
      onOk={async () => {
        const data = await form.validateFields();
        console.log('data', data);
        if (isEmpty(data.selectedCategories) && isEmpty(data.regularQuestion)) {
          message.warning('请设置随机抽题或固定题目');
        } else {
          if (!data.id) {
            data.id = create32LengthUUID();
          }
          onOk(data);
        }
      }}
    >
      {activeExercise ? (
        <Form
          preserve={false}
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          initialValues={activeExercise ? { ...activeExercise } : {}}
        >
          {formDom()}
        </Form>
      ) : (
        <Form
          preserve={false}
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ title: undefined }}
        >
          {formDom()}
        </Form>
      )}
    </Modal>
  );
};
export default ExerciseModal;
